import SidebarActionTypes from './sidebar.ypes';

export const changeSidebarVisibility = () => ({
  type: SidebarActionTypes.CHANGE_SIDEBAR_VISIBILITY,
});
export const changeMobileSidebarVisibility = () => ({
  type: SidebarActionTypes.CHANGE_MOBILE_SIDEBAR_VISIBILITY,
});
